/**
 * Auto-cycles product card images every 3 seconds with slide-from-right animation.
 * Unhides all product images and disables hover swap behavior.
 * Disables Trilogy section-level carousel auto-loop.
 */
(function () {
  var SECTION_IDS = ['product_list_pgXkhP', 'product_list_EGgWrN', 'main'];
  var CYCLE_SPEED = 3000;
  var SLIDE_DURATION = 800;

  function disableTrilogySectionCarousel() {
    var trilogySection = document.querySelector('[id*="product_list_pgXkhP"]');
    if (!trilogySection) return;
    var sectionSlideshow = trilogySection.querySelector(':scope > * > slideshow-component, :scope > slideshow-component');
    if (sectionSlideshow) {
      sectionSlideshow.removeAttribute('autoplay');
      sectionSlideshow.removeAttribute('infinite');
    }
    var paginatedList = trilogySection.querySelector('paginated-list');
    if (paginatedList) {
      var topSlideshow = paginatedList.querySelector(':scope > slideshow-component');
      if (topSlideshow) {
        topSlideshow.removeAttribute('autoplay');
        topSlideshow.removeAttribute('infinite');
      }
    }
  }

  function initAutoplay() {
    SECTION_IDS.forEach(function (sectionId) {
      var section = document.querySelector(
        '[id*="' + sectionId + '"], [data-section-id="' + sectionId + '"]'
      );
      if (!section) return;

      var productCards = section.querySelectorAll('product-card');
      productCards.forEach(function (card) {
        var gallery = card.querySelector('[ref="cardGallery"], .card-gallery');
        if (!gallery) return;

        // Remove hover image swap events
        gallery.removeAttribute('on:pointerenter');
        gallery.removeAttribute('on:pointerleave');

        var scroller = gallery.querySelector('slideshow-slides, [ref="scroller"]');
        if (!scroller) return;

        // Unhide ALL slides (theme hides non-first slides)
        var allSlides = Array.from(scroller.querySelectorAll('slideshow-slide'));
        allSlides.forEach(function (slide) {
          slide.removeAttribute('hidden');
          slide.setAttribute('aria-hidden', 'false');
        });

        // Filter to only visible non-variant slides
        var visibleSlides = allSlides.filter(function (slide) {
          return !slide.hasAttribute('variant-image');
        });
        if (visibleSlides.length <= 1) visibleSlides = allSlides;
        if (visibleSlides.length <= 1) return;

        // Hide any dots/arrows
        var controls = gallery.querySelectorAll('slideshow-controls, slideshow-arrows');
        controls.forEach(function (ctrl) {
          ctrl.style.display = 'none';
        });

        // Setup container for slide animation
        scroller.style.overflow = 'hidden';
        scroller.style.scrollSnapType = 'none';
        scroller.style.display = 'grid';
        scroller.style.gridTemplateColumns = '1fr';
        scroller.style.gridTemplateRows = '1fr';

        // Stack all slides
        visibleSlides.forEach(function (slide, i) {
          slide.style.gridArea = '1 / 1';
          slide.style.minWidth = '100%';
          slide.style.visibility = 'visible';
          slide.style.display = 'block';
          slide.style.transition = 'transform ' + SLIDE_DURATION + 'ms cubic-bezier(0.25, 0.1, 0.25, 1)';
          if (i === 0) {
            slide.style.transform = 'translateX(0)';
            slide.style.zIndex = '2';
          } else {
            slide.style.transform = 'translateX(100%)';
            slide.style.zIndex = '1';
          }
        });

        // Hide non-participating slides
        allSlides.forEach(function (slide) {
          if (visibleSlides.indexOf(slide) === -1) {
            slide.style.display = 'none';
          }
        });

        var currentIndex = 0;
        var totalSlides = visibleSlides.length;

        setInterval(function () {
          var prevIndex = currentIndex;
          currentIndex = (currentIndex + 1) % totalSlides;

          // Next slide: start from right
          visibleSlides[currentIndex].style.transition = 'none';
          visibleSlides[currentIndex].style.transform = 'translateX(100%)';
          visibleSlides[currentIndex].style.zIndex = '3';

          // Force reflow
          void visibleSlides[currentIndex].offsetWidth;

          // Animate next slide in from right
          visibleSlides[currentIndex].style.transition = 'transform ' + SLIDE_DURATION + 'ms cubic-bezier(0.25, 0.1, 0.25, 1)';
          visibleSlides[currentIndex].style.transform = 'translateX(0)';

          // Animate current slide out to left
          visibleSlides[prevIndex].style.zIndex = '2';
          visibleSlides[prevIndex].style.transform = 'translateX(-100%)';

          // Reset previous slide after animation
          setTimeout(function () {
            visibleSlides[prevIndex].style.transition = 'none';
            visibleSlides[prevIndex].style.transform = 'translateX(100%)';
            visibleSlides[prevIndex].style.zIndex = '1';
          }, SLIDE_DURATION + 50);
        }, CYCLE_SPEED);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(function () {
        disableTrilogySectionCarousel();
        initAutoplay();
      }, 1500);
    });
  } else {
    setTimeout(function () {
      disableTrilogySectionCarousel();
      initAutoplay();
    }, 1500);
  }
})();
